import { debuggerErrorCodes, ErrorCode, publicErrorDetails } from "./ErrorCodes";

function isPublicErrorCode(errorCode: ErrorCode): boolean {
    const publicError = Object.values(ErrorCode).find((code: ErrorCode) => code === errorCode);
    return !!publicError;
}

export function isKnownErrorCode(errorCode: ErrorCode): boolean {
    return isPublicErrorCode(errorCode);
}

export function isDebuggerErrorCode(errorCode: ErrorCode): boolean {
    return debuggerErrorCodes.includes(errorCode);
}

function getPublicErrorCodeMessage(errorCode: ErrorCode): string | undefined {
    return publicErrorDetails[errorCode];
}

export function getMessage(errorCode: ErrorCode): string {
    return getPublicErrorCodeMessage(errorCode) ?? "Error";
}

export function isDownstreamErrorCode(errorCode: ErrorCode | undefined): boolean {
    return !errorCode || errorCode === ErrorCode.NetworkError || errorCode === ErrorCode.UnknownError;
}
